"use client"

import { useState } from "react"
import SalaForm from "../components/Salas/SalaForm"
import SalaList from "../components/Salas/SalaList"
import "../styles/SalasPage.css"

export default function SalasPage() {
  const [updateList, setUpdateList] = useState(false)
  const [salaParaEditar, setSalaParaEditar] = useState(null)

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setSalaParaEditar(null)
  }

  const handleEdit = (sala) => {
    setSalaParaEditar(sala)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setSalaParaEditar(null)
  }

  return (
    <div className="salas-page">
      <h1 className="page-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        Gestão de Salas
      </h1>

      <SalaForm onAdded={handleAdded} salaParaEditar={salaParaEditar} onCancelEdit={handleCancelEdit} />

      <SalaList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
